module.exports = __webpack_public_path__ + "static/media/Upp3.708adb25.png";